// src/pages/MyEarnings.js
import React from 'react';
import { Button, Modal, Form } from 'react-bootstrap';

/**
 * Simplified “My Earnings” page – notice + backup-key link.
 *
 * Expects the same backup-modal props that the previous (full) page used:
 *   • showBackupModal / setShowBackupModal
 *   • showPrivateKey / setShowPrivateKey
 *   • privateKeyToShow / setPrivateKeyToShow
 *   • backupPassword / setBackupPassword
 *   • handleBackupPrivateKeyEvent
 *
 * If those props aren’t supplied, nothing will break visually, but the modal
 * won’t open (provide them from the parent container exactly as before).
 */
const MyEarnings = ({
  /* Backup-key modal state & handlers (passed down from parent) */
  showBackupModal = false,
  setShowBackupModal = () => {},
  showPrivateKey = false,
  setShowPrivateKey = () => {},
  privateKeyToShow = '',
  setPrivateKeyToShow = () => {},
  backupPassword = '',
  setBackupPassword = () => {},
  handleBackupPrivateKeyEvent = (e) => e.preventDefault()
}) => (
  <div
    style={{
      minHeight: '60vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      color: '#fff',
      padding: '20px'
    }}
  >
    <p style={{ fontSize: '1.2rem' }}>
      Earnings management has moved to{' '}
      <a
        href="https://dashboard.sogni.ai"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#b5ff16', textDecoration: 'underline' }}
      >
        dashboard.sogni.ai
      </a>.
    </p>

    {/* ---------- Backup-key link ---------- */}
    <p style={{ marginTop: '16px' }}>
      <a
        href="#backup"
        onClick={(e) => {
          e.preventDefault();
          setShowBackupModal(true);
        }}
        style={{
          color: '#b5ff16',
          textDecoration: 'underline',
          fontSize: '1rem'
        }}
      >
        Back up your Private Key
      </a>
    </p>

    {/* ---------- Backup Private Key Modal (original logic) ---------- */}
    <Modal
      show={showBackupModal}
      onHide={() => {
        setShowBackupModal(false);
        setBackupPassword('');
        setShowPrivateKey(false);
        setPrivateKeyToShow('');
      }}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Backup Private Key</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!showPrivateKey ? (
          <Form onSubmit={handleBackupPrivateKeyEvent}>
            <Form.Group controlId="backupPassword">
              <Form.Label>Enter Password to Confirm</Form.Label>
              <Form.Control
                type="password"
                value={backupPassword}
                onChange={(e) => setBackupPassword(e.target.value)}
              />
            </Form.Group>
            <Button variant="primary" className="mt-3" type="submit">
              Reauthenticate
            </Button>
          </Form>
        ) : (
          <div style={{ wordWrap: 'break-word' }}>
            <p>
              <strong>Private Key:</strong> {privateKeyToShow}
            </p>
            <Button
              variant="secondary"
              onClick={() => {
                setShowPrivateKey(false);
                setShowBackupModal(false);
                setPrivateKeyToShow('');
                setBackupPassword('');
              }}
            >
              Done
            </Button>
          </div>
        )}
      </Modal.Body>
    </Modal>
  </div>
);

export default MyEarnings;
